import { render, staticRenderFns } from "./refuseDialog.vue?vue&type=template&id=3d054d61&"
import script from "./refuseDialog.vue?vue&type=script&lang=js&"
export * from "./refuseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports